var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:{ 'nav-mobile-contain': _vm.isSmallerThanTabletPortrait, 'fixed-top-nav': true }},[_c('nav',{staticClass:"top-nav",attrs:{"aria-label":_vm.__('Header')}},[_c('div',{staticClass:"logo-container"},[_c('PadletLogo',{staticClass:"w-20 h-5",attrs:{"dark-mode":_vm.darkMode}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }